<template lang="pug">
div
  customer-search(@onHit='setCustomer', size="sm")
  b-modal(
    ref="modal",
    lazy,
    centered,
    size="lg",
    title="Add Commission",
    ok-only,
    ok-title="Done",
    :busy="busy",
    hide-header-close)
    h6(v-if="customer") {{ customer.name }}
    .table-responsive(style="max-height: 75vh"): table.table.table-striped.table-sm.table-hover.table-bordered.m-0
      thead.thead-dark: tr
        th Company
        th Policy #
        th Status
        th Product
        th Effective
        th Expiration
        th Premium
        th Commission
      tbody: tr(v-for='p in policies', :key='p.id')
        td.truncate {{ p.company }}
        td.monospace {{ p.policy }}
        td.monospace {{ p.status }}
        td.truncate {{ p.product }}
        td.monospace.text-center {{ p.effdate }}
        td.monospace.text-center {{ p.expdate }}
        td.monospace: .d-flex.justify-content-between
          span $
          span {{ p.premium | number }}
        td.monospace
          form.form-inline(@submit.prevent="addCommission(p)")
            .input-group.input-group-sm
              numeric.form-control.text-right(
                currency='$',
                v-model='p.commission',
                :precision='2',
                :minus='true',
                tabindex="0")
              .input-group-append: button.btn.btn-primary(
                type="submit",
                :disabled='p.pending',
                tabindex="-1") Add

    .alert.alert-danger(role='alert', v-show='error') {{ error }}
</template>

<script>
import Numeric from 'vue-numeric'
import CustomerSearch from '@/components/CustomerSearch'
import makesAjaxRequests from '@/mixins/makesAjaxRequests'

export default {
  name: 'CustomerForm',

  mixins: [makesAjaxRequests],

  components: {
    CustomerSearch,
    Numeric
  },

  props: {
    file: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      customer: null,
      policies: [],
      error: null
    }
  },

  methods: {
    reset () {
      this.$refs.modal.hide()
      this.customer = null
      this.policies = []
    },

    setCustomer (customer) {
      this.reset()
      this.customer = customer
      this.$refs.modal.show()
      this.ajaxCall(this.$http.get(`commission/employee/policies/${customer.id}`).then(resp => {
        console.info(resp)
        this.policies = resp.data.map(p => ({
          ...p,
          commission: 0,
          pending: false
        }))
      }))
    },

    addCommission (policy) {
      policy.pending = true

      this.ajaxCall(this.$http.post(`commission/file/${this.file.id}/details/manual`, {
        policy: policy.id,
        amount: policy.commission
      }).then(resp => {
        this.policies.splice(this.policies.indexOf(policy), 1)

        if (this.policies.length === 0) {
          this.reset()
        }

        this.$emit('detailCreated', resp.data)
      }).catch(() => {
        policy.pending = false
      }))
    }
  }
}
</script>
